import flowRight from 'lodash/flowRight';

import { RouteItemType } from '~/core/router';
import {
  withHomeScreenRetentionLayout,
  withMainLayout,
  withOnboardingLayout,
  withPromoModalLayout,
  withSubModalsLayout,
} from '~/decorators/withLayout';
import lazyComponentLoader from '~/helpers/lazyComponentLoader';
import {
  getImageGeneratorTitle,
  ImageGeneratorPath,
} from '~/modules/image-generator/constants';

const ImageGenerator = lazyComponentLoader(() => import('./ImageGenerator'));

export const ImageGeneratorRoute: RouteItemType = {
  Component: flowRight(
    withPromoModalLayout,
    withSubModalsLayout,
    withOnboardingLayout,
    withHomeScreenRetentionLayout,
    withMainLayout,
  )(ImageGenerator),
  path: ImageGeneratorPath,
  getTitle: getImageGeneratorTitle,
};
